<template>
  <div class="flex gap-4 mt-8 mb-4 lg:hidden">
    <a href="https://github.com/DominoxB" target="_blank">
      <img src="@/icons/github-white.png" alt="github" class="w-6 h-6" />
    </a>
    <a href="https://www.linkedin.com/in/dominika-biedulska" target="_blank">
      <img src="@/icons/linkedin.svg" alt="linkedin" class="bg-white rounded w-6 h-6" />
    </a>
  </div>
</template>
